var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAroplaneBedDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.655,
    height: 8.274,
    viewBox: "0 0 28.655 8.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7706",
    "data-name": "Group 7706",
    transform: "translate(0 -2.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "airplane",
    d: "M1.144,2.663a.3.3,0,0,1,.282.016L3.334,3.854a.3.3,0,0,0,.291.012l5.907-3a6.118,6.118,0,0,1,3.443-.85s1.392-.149,1.242.847c-.144.957-3.231,2.281-4.175,2.558a.291.291,0,0,0-.164.126L7.95,6.6a.3.3,0,0,1-.143.119l-1.168.46a.3.3,0,0,1-.407-.26L6.135,5.3a.3.3,0,0,0-.4-.261A15.555,15.555,0,0,1,.789,6.13c-.214,0,.24-.54.512-.844a.3.3,0,0,0-.005-.4L.081,3.593a.3.3,0,0,1,.091-.476Z",
    transform: "translate(0 3.17) rotate(-3)",
    fill: "#091e30"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_-_bed",
    "data-name": "icon - bed",
    transform: "translate(17.671 2.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M10.645,0H.338A.394.394,0,0,0,0,.432V2.659a.393.393,0,0,0,.338.432H.373v.8A.1.1,0,0,0,.458,4h.887a.1.1,0,0,0,.085-.108v-.8H9.554v.8A.1.1,0,0,0,9.638,4h.887a.1.1,0,0,0,.085-.108v-.8h.035a.393.393,0,0,0,.338-.432V.432A.393.393,0,0,0,10.645,0",
    transform: "translate(0 4)",
    fill: "#091e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M1.088,2.92H1.36V1.769a.361.361,0,0,1,.363-.36H4.608a.361.361,0,0,1,.363.36V2.92H6.013V1.769a.361.361,0,0,1,.363-.36H9.261a.361.361,0,0,1,.363.36V2.92H9.9A1.084,1.084,0,0,1,10.983,4V1.08A1.084,1.084,0,0,0,9.9,0H1.088A1.084,1.084,0,0,0,0,1.08V4A1.084,1.084,0,0,1,1.088,2.92",
    fill: "#091e30"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAroplaneBedDark);
export default __webpack_public_path__ + "static/media/aroplane-bed-dark.ba58ebb9a4df36c739697b21003bc127.svg";
export { ForwardRef as ReactComponent };